"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfListOverrideLevel = void 0;
var constants_1 = require("@devexpress/utils/lib/constants");
var rtf_list_level_1 = require("./rtf-list-level");
var RtfListOverrideLevel = (function () {
    function RtfListOverrideLevel() {
        this.startAt = constants_1.Int32Constants.MAX_VALUE;
        this.level = new rtf_list_level_1.RtfListLevel();
    }
    return RtfListOverrideLevel;
}());
exports.RtfListOverrideLevel = RtfListOverrideLevel;
